import React, { Fragment, FunctionComponent } from 'react';
import "../error.scss"
import Text from '../../../components/typography/typgraphy';
import { IErrorPageProps } from '../../../constants/commonTypes';

// TODO: Remove conditional rendering after PartnerName is integrated with Login API
const DemogNotFoundError: FunctionComponent<IErrorPageProps> = ({ partnerName }) => {
  return (
    <Fragment>
      <Text className="error-description">Seems like your Account details is not available.</Text>
      <Text className="error-description">Please re initiate the transaction {partnerName ? "from " + partnerName : ''} and try again.</Text>
    </Fragment>
  )
}

export default DemogNotFoundError;
